/* src/app/components/doc-viewer-new/doc-viewer-right-panel/doc-viewer-doc-tab/doc-viewer-doc-tab.component.scss */
.section-header {
  background: #E4E4E4;
  border-top: 1px solid #F0F0F0;
  border-right: 1px solid #F0F0F0;
  border-left: 1px solid #F0F0F0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 24px;
  padding-top: 8px;
}
:host-context(.dark-theme) .section-header {
  background: rgba(25, 25, 25, 0.9294117647);
  border-top: 1px solid rgba(58, 58, 58, 0.8196078431);
  border-right: 1px solid rgba(58, 58, 58, 0.8196078431);
  border-left: 1px solid rgba(58, 58, 58, 0.8196078431);
}
.area-header {
  color: #000000;
  font-weight: 600;
  margin-left: 4px;
}
.detail-item {
  width: 100%;
  margin: 2px;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}
.icon-alternate {
  color: rgb(36, 62, 144);
}
.action-item {
  display: none;
  cursor: pointer;
  margin-right: 4px;
}
.action-icon {
  color: rgb(36, 62, 144);
  background-color: inherit;
}
:host-context(.dark-theme) .action-icon {
  color: rgb(255, 193, 7);
}
.icon-alternate {
  color: inherit;
}
.detail-item:hover .inner-text {
  font-size: 13px;
  font-weight: 500;
}
.label {
  font-size: 13px;
  transition: all 0.3s ease;
}
.inner-text {
  margin-top: 4px;
  font-size: 13px;
  transition: all 0.3s ease;
}
:host-context(.dark-theme) .area-header {
  color: #FFF;
}
label {
  color: rgb(36, 62, 144);
  font-weight: 500;
}
:host-context(.dark-theme) label {
  color: #FFC107;
  font-weight: 600;
}
.mat-grid-list {
  border: 1px solid #f1f1f1;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.mat-grid-list .detail-item {
  margin-left: 6px;
}
:host-context(.dark-theme) .mat-grid-list {
  border: 1px solid rgba(58, 58, 58, 0.8196078431);
}
.mat-grid-tile {
  border: 1px solid #f1f1f1;
}
.mat-grid-tile:hover .action-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.mat-grid-tile:hover .action-item button {
  color: inherit;
  background-color: inherit;
  cursor: pointer;
  border: unset;
}
.flex {
  display: flex !important;
}
.none {
  display: none !important;
}
:host-context(.dark-theme) .mat-grid-tile {
  border: 1px solid #3F3F3F;
}
.mat-grid-tile:last-child {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.grid-list {
  border: 1px solid #f1f1f1;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  display: flex;
  flex-direction: column;
}
:host-context(.dark-theme) .grid-list {
  border: 1px solid rgba(58, 58, 58, 0.8196078431);
}
.grid-tile {
  padding: 6px 4px;
  border-bottom: 1px solid #f1f1f1;
  border-right: 1px solid #f1f1f1;
  border-left: 1px solid #f1f1f1;
}
.grid-tile:hover .action-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.grid-tile:hover .action-item button {
  color: inherit;
  background-color: inherit;
  cursor: pointer;
  border: unset;
}
:host-context(.dark-theme) .grid-tile {
  border-bottom: 1px solid #3F3F3F;
  border-right: 1px solid #3F3F3F;
  border-left: 1px solid #3F3F3F;
}
.grid-tile:last-child {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
mat-grid-tile div div {
  color: #000000;
  font-weight: 400;
}
:host-context(.dark-theme) mat-grid-tile div div {
  color: #FFF;
}
:host ::ng-deep div.mat-grid-tile-content {
  justify-content: flex-start !important;
}
:host ::ng-deep .mat-mdc-standard-chip {
  background-color: #E4E4E4;
  border-radius: 12px;
  min-height: 18px;
  font-size: 13px;
  font-weight: 300;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host-context(.dark-theme) .mat-mdc-standard-chip {
  background-color: black;
}
.show-more {
  cursor: pointer;
}
:host-context(.dark-theme) .show-more {
  background-color: #3F3F3F !important;
}
.connections-list {
  margin-top: 3px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 4px;
}
.connection-item {
  background-color: #f1f1f1;
  color: #000;
  border-radius: 5px;
  min-height: 20px;
  width: max-content;
  max-width: 300px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 12px;
}
.connection-item .connection-text {
  cursor: text;
  font-size: 13px;
  font-weight: 300;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
:host-context(.dark-theme) .connection-item {
  background-color: #000;
  color: #fff;
}
:host-context(.dark-theme) .connections-subject {
  color: white;
}
.audit-item {
  background-color: #E4E4E4;
  color: rgb(36, 62, 144);
  box-shadow: none;
}
.show-more-audits {
  background-color: #E4E4E4;
  color: rgb(36, 62, 144);
}
input {
  background-color: rgba(252, 252, 252, 0.6862745098);
  border: 1px solid #243e90;
  border-radius: 5px;
  padding: 8px;
  outline: none;
  color: inherit;
  background: inherit;
  transition: box-shadow 0.2s;
}
input:focus {
  background-color: rgba(252, 252, 252, 0.6862745098);
  border-color: #283593;
  box-shadow: 0 0 3px rgba(40, 52, 147, 0.6862745098);
}
:host-context(.dark-theme) .audit-item {
  background-color: #424242;
  color: white;
  border: 0;
}
:host-context(.dark-theme) .show-more-audits {
  color: #FFC107;
  background-color: #424242;
}
:host-context(.dark-theme) input {
  border: 1px solid rgba(255, 255, 255, 0.1882352941);
  border-radius: 5px;
  padding: 8px;
  outline: none;
  color: inherit;
  background: inherit;
  transition: box-shadow 0.2s;
}
:host-context(.dark-theme) input:focus {
  border-color: #D0A010;
  box-shadow: 0 0 3px #b18a16;
}
.datepicker-container {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin: 0px 12px 0px 6px;
}
.datepicker-container button {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}
.hidden-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
.hidden {
  visibility: hidden;
  position: absolute;
}
.custom-mat-form-field {
  border: none;
  padding: 0;
  margin: 0;
  min-width: 0;
}
.bates-input-container {
  background-color: rgba(252, 252, 252, 0.6862745098);
  border: 1px solid #243e90;
  border-radius: 5px;
  padding: 2px 5px;
  outline: none;
  color: inherit;
  background: inherit;
  transition: box-shadow 0.2s;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: border-color 0.3s;
}
.bates-input-container input:focus {
  border-radius: 6px;
  background-color: rgba(235, 235, 235, 0.5019607843);
}
.bates-input-container:hover {
  background-color: rgba(252, 252, 252, 0.6862745098);
  border-color: #283c93;
  box-shadow: 0 0 3px rgba(40, 52, 147, 0.6862745098);
}
.bates-input-container:focus-within {
  border-color: #283c93;
  box-shadow: 0 0 2px rgba(40, 52, 147, 0.6862745098);
}
.bates-prefix,
.bates-number-start,
.bates-number-digits {
  border: none;
  outline: none;
  padding: 5px;
}
.bates-prefix {
  flex: 1 1 40%;
  width: 40%;
}
.bates-number-start {
  flex: 1 1 40%;
  width: 40%;
}
.bates-number-digits {
  flex: 1 1 20%;
  width: 20%;
}
.error {
  color: red;
  margin-top: 5px;
}
:host-context(.dark-theme) .bates-input-container {
  border: 1px solid rgba(255, 255, 255, 0.1882352941);
  border-radius: 5px;
  outline: none;
  color: inherit;
  background: inherit;
  transition: box-shadow 0.2s;
}
:host-context(.dark-theme) .bates-input-container input {
  border: unset;
}
:host-context(.dark-theme) .bates-input-container input:focus {
  background-color: rgba(235, 235, 235, 0.16);
  box-shadow: 0 0 3px #b18a16;
  border: unset;
}
:host-context(.dark-theme) .bates-input-container select:focus {
  border-radius: 6px;
  background-color: rgba(235, 235, 235, 0.16);
  box-shadow: 0 0 3px #b18a16;
}
:host-context(.dark-theme) .bates-input-container:hover {
  border-color: #D0A010;
  box-shadow: 0 0 3px #b18a16;
}
mat-card:first-of-type {
  margin-top: 12px;
  margin-bottom: 4px;
}
mat-card:not(:first-of-type) {
  margin-top: 6px;
  margin-bottom: 4px;
}
/*# sourceMappingURL=doc-viewer-doc-tab.component.css.map */
